import { Avatar, Icon, Typography } from '@/components/common';
import Icons from '@/const/icons';
import clsx, { ClassValue } from 'clsx';
import { ReactNode } from 'react';
import Link from 'next/link';

interface AvatarNameProps {
	name?: string;
	firstname?: string;
	lastname?: string;
	photoUrl: string;
	isBold?: boolean;
	size: 'small' | 'extra-small';
	classNameText?: ClassValue;
	classNameAvatar?: ClassValue;
	classNameContainer?: ClassValue;
	className?: ClassValue;
	subtitle?: ReactNode;
	smallText?: string;
	profileRedirect?: string;
}

export const AvatarName: React.FC<AvatarNameProps> = ({
	name,
	firstname,
	lastname,
	photoUrl,
	isBold,
	size,
	className,
	classNameText,
	classNameAvatar,
	classNameContainer,
	profileRedirect,
	subtitle,
	smallText,
}) => {
	const content = (
		<div className={clsx('flex items-center gap-2', classNameContainer)}>
			<div>
				<Avatar
					photoUrl={photoUrl}
					size={size}
					className={classNameAvatar}
					firstname={firstname}
					lastname={lastname}
				/>
			</div>
			<div className={clsx('flex items-center gap-x-1 relative', className)}>
				<Typography
					type="regular-14"
					text={name ? name : firstname ? `${firstname} ${lastname}` : 'N/N'}
					className={clsx(
						{
							'font-semibold line-clamp-1': isBold,
						},
						classNameText
					)}
				/>
				{smallText && (
					<Typography type="regular-14" className="text-left absolute top-6">
						{smallText}
					</Typography>
				)}

				{subtitle && subtitle}

				{profileRedirect && (
					<Icon
						src={Icons.arrowUpRight}
						className="size-4"
						width={16}
						height={16}
					/>
				)}
			</div>
		</div>
	);
	return profileRedirect ? (
		<Link href={profileRedirect} className="flex items-center gap-2">
			{content}
		</Link>
	) : (
		content
	);
};
